export const SET_QUESTION_USE_QUESTION = 'SET_QUESTION_USE_QUESTION';
export const SET_QUESTION_QUESTION = 'SET_QUESTION_QUESTION';
export const SET_QUESTION_QUESTION_DESC = 'SET_QUESTION_QUESTION_DESC';
export const SET_QUESTION_MANDATORY = 'SET_QUESTION_MANDATORY';
export const SET_QUESTION_TYPE = 'SET_QUESTION_TYPE';
export const SET_QUESTION_MAX_CHOICE = 'SET_QUESTION_MAX_CHOICE';
export const SET_QUESTION_TEXT_LENGTH = 'SET_QUESTION_TEXT_LENGTH';
export const SET_QUESTION_TABLE_COLUMN_LENGTH = 'SET_QUESTION_TABLE_COLUMN_LENGTH';
export const SET_QUESTION_PARENT_ANSWER_CONDITION = 'SET_QUESTION_PARENT_ANSWER_CONDITION';
export const SET_QUESTION_PARENT_FCFS = 'SET_QUESTION_PARENT_FCFS';

export const mutations = {
    setQuestionUseQuestion(state, {question, isUseQuestion}) {
        question.isUseQuestion = isUseQuestion;
    },

    setQuestionQuestion(state, {question, text}) {
        question.question = text;
    },

    setQuestionQuestionDesc(state, {question, text}) {
        question.questionDesc = text;
    },

    setQuestionMandatory(state, {question, mandatory}) {
        question.mandatory = mandatory;
    },

    setQuestionType(state, {question, type}) {
        question.type = type;
    },

    setQuestionMaxChoice(state, {question, maxChoice}) {
        question.maxChoice = maxChoice;
    },

    setQuestionTextLength(state, {question, textLength}) {
        question.textLength = textLength;
    },

    setQuestionTableColumnLength(state, {question, tableColumnLength}) {
        question.tableColumnLength = tableColumnLength;
    },

    setQuestionParentAnswerCondition(state, {question, parentAnswerCondition}) {
        question.parentAnswerCondition = parentAnswerCondition;
    },

    setQuestionParentFCFS(state, {question, isParentFCFS}) {
        question.isParentFCFS = isParentFCFS;
    },
};

export const actions = {
    [SET_QUESTION_USE_QUESTION]({commit}, {question, isUseQuestion}) {
        commit('setQuestionUseQuestion', {question, isUseQuestion});
    },

    [SET_QUESTION_QUESTION]({commit}, {question, text}) {
        commit('setQuestionQuestion', {question, text});
    },

    [SET_QUESTION_QUESTION_DESC]({commit}, {question, text}) {
        commit('setQuestionQuestionDesc', {question, text});
    },

    [SET_QUESTION_MANDATORY]({commit}, {question, mandatory}) {
        commit('setQuestionMandatory', {question, mandatory});
    },

    [SET_QUESTION_TYPE]({commit}, {question, type}) {
        commit('setQuestionType', {question, type});
    },

    [SET_QUESTION_MAX_CHOICE]({commit}, {question, maxChoice}) {
        commit('setQuestionMaxChoice', {question, maxChoice});
    },

    [SET_QUESTION_TEXT_LENGTH]({commit}, {question, textLength}) {
        commit('setQuestionTextLength', {question, textLength});
    },

    [SET_QUESTION_TABLE_COLUMN_LENGTH]({commit}, {question, tableColumnLength}) {
        commit('setQuestionTableColumnLength', {question, tableColumnLength});
    },

    [SET_QUESTION_PARENT_ANSWER_CONDITION]({commit}, {question, parentAnswerCondition}) {
        commit('setQuestionParentAnswerCondition', {question, parentAnswerCondition});
    },

    [SET_QUESTION_PARENT_FCFS]({commit}, {question, isParentFCFS}) {
        commit('setQuestionParentFCFS', {question, isParentFCFS});
    },
};
